// extracted by mini-css-extract-plugin
module.exports = {"container":"assignment_container__2DMrh","iframeContainer":"assignment_iframeContainer__3Waja"};